(function () {
  'use strict';

  function root() { return document.querySelector('[data-ma-handoff-pdp="true"]'); }
  function titleCard() { return document.querySelector('[data-ma-handoff-title-card]'); }
  // Run `fn` once on the next animation frame. Repeated calls within the same
  // frame collapse into one run, so a burst of events costs a single DOM update.
  function schedule(fn) {
    if (fn._maFrame) cancelAnimationFrame(fn._maFrame);
    fn._maFrame = requestAnimationFrame(function () {
      fn._maFrame = 0;
      fn();
    });
  }

  function numericMoney(text) {
    if (!text) return NaN;
    var cleaned = String(text).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    return parseFloat(cleaned);
  }

  function priceText(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function syncTitlePrice() {
    var r = root(), card = titleCard();
    if (!r || !card) return;
    var row = r.querySelector('#pdp-price-row');
    var out = card.querySelector('[data-ma-title-price-values]');
    if (!row || !out) return;

    var finalEl = row.querySelector('.pdp-final-price') || row.querySelector('[data-product-price]') || row.querySelector('#pdp-price-display');
    var compareEl = row.querySelector('.pdp-original-price') || row.querySelector('#pdp-compare-price') || row.querySelector('[data-compare-price]');
    var finalText = priceText(finalEl), compareText = priceText(compareEl);
    if (!finalText) return;

    out.innerHTML = '';
    var finalNode = document.createElement('strong');
    finalNode.textContent = finalText;
    if (compareText && compareText !== finalText) {
      var compareNode = document.createElement('s');
      compareNode.textContent = compareText;
      out.appendChild(compareNode);
      out.appendChild(document.createTextNode(' '));
    }
    out.appendChild(finalNode);

    var priceWrap = card.querySelector('[data-ma-title-price]');
    var finalNum = numericMoney(finalText), compareNum = numericMoney(compareText);
    var onSale = Number.isFinite(finalNum) && Number.isFinite(compareNum) && compareNum > finalNum;
    var pct = onSale ? Math.round((compareNum - finalNum) / compareNum * 100) : 0;
    if (priceWrap) priceWrap.classList.toggle('is-sale', onSale);

    syncTitleSaleLine(card, row);
    syncPurchaseSaleState(onSale);
    setFromState(window.__maSelection || null);
  }

  // The sale message beneath the title price is a copy of the one the price engine shows next
  // to the purchase-card price (#pdp-discount-tag: "LIMITED TIME: 20% Off", including its
  // first-order and BOGO variants): same text, shown and hidden together, so the two can never
  // disagree. No tag in the purchase card means no line under the title.
  function syncTitleSaleLine(card, row) {
    var line = card.querySelector('[data-ma-title-sale-line]');
    if (!line) return;

    var tag = row.querySelector('#pdp-discount-tag');
    var tagShown = tag && window.getComputedStyle(tag).display !== 'none';
    var text = tagShown ? priceText(tag) : '';

    if (line.textContent !== text) line.textContent = text;
    line.hidden = !text;
    card.classList.toggle('has-sale-line', !!text); // reserves the line's height (CSS)
    fitSaleLine(card, line);
  }

  // On phones the sale line sits right-aligned under the title price (CSS: absolute, right: 0,
  // nowrap). A long message, such as "Limited Time: Buy One, Get One Free" under a single price,
  // would run off the left edge of the screen. When the line does not fit inside the title card,
  // centre it under the price-and-reviews row instead; if it is wider than the card, let it wrap
  // (centred). Short messages ("Limited Time: 20% Off") keep their usual place.
  function fitSaleLine(card, line) {
    if (!line) return;
    ['left', 'right', 'white-space', 'width', 'text-align', 'justify-content'].forEach(function (p) {
      line.style.removeProperty(p);
    });
    if (line.hidden || !line.textContent || window.getComputedStyle(line).position !== 'absolute') return;
    var box = line.offsetParent;
    if (!box) return;

    var cs = window.getComputedStyle(card), cr = card.getBoundingClientRect();
    var minX = cr.left + (parseFloat(cs.paddingLeft) || 0);
    var maxX = cr.right - (parseFloat(cs.paddingRight) || 0);
    var r = line.getBoundingClientRect();
    if (r.left >= minX - 0.5 && r.right <= maxX + 0.5) return;

    var b = box.getBoundingClientRect();
    if (r.width > maxX - minX) {
      line.style.setProperty('white-space', 'normal', 'important');
      line.style.setProperty('width', Math.floor(maxX - minX) + 'px', 'important');
      line.style.setProperty('text-align', 'center', 'important');
      line.style.setProperty('justify-content', 'center', 'important');
    }
    var w = Math.min(r.width, maxX - minX);
    var x = minX + Math.max(0, (maxX - minX - w) / 2);
    // Inline !important is needed to beat the stylesheet's `right: 0 !important`.
    line.style.setProperty('right', 'auto', 'important');
    line.style.setProperty('left', Math.round(x - b.left) + 'px', 'important');
  }

  function refitSaleLine() {
    var card = titleCard();
    if (card) fitSaleLine(card, card.querySelector('[data-ma-title-sale-line]'));
  }

  function syncPurchaseSaleState(onSale) {
    var r = root(); if (!r) return;
    var pricing = r.querySelector('[data-ma-purchase-pricing]');
    if (!pricing) return;

    // `is-sale` drives the red sale price styling in the lower purchase card.
    pricing.classList.toggle('is-sale', !!onSale);

    // No separate "Limited time: N% Off" line is added down here. The lower
    // price row is a clone of the live price row, which already carries the
    // price engine's own "LIMITED TIME: N% Off" tag, and the row is laid
    // out on one line: a second label does not fit at 390px. (An earlier
    // version appended one, but the row was rebuilt on every sync, so the
    // label was removed again before it could paint and never showed in the
    // approved design.) Remove any leftover from older markup.
    var leftover = pricing.querySelector('.ma-pdp-purchase-sale-line');
    if (leftover) leftover.remove();
  }

  function hasAnySelection(detail) {
    if (detail && Array.isArray(detail.values) && detail.values.some(Boolean)) return true;

    // The PDP section is morphed after native variant changes. Read the
    // persistent customizer state as the primary fallback so the newly
    // rendered title card cannot bring "From" back after the first choice.
    var customizer = document.querySelector('[data-ma-pdp-mobile]');
    if (customizer && window.__maPdpMobileSelections) {
      var key = customizer.dataset.productId + ':' + customizer.dataset.sectionId;
      var stored = window.__maPdpMobileSelections[key];
      if (stored && (stored.frame || stored.size)) return true;
    }

    // Final DOM fallback for the currently rendered custom cards.
    return !!document.querySelector(
      '[data-ma-option="frame"].is-selected, [data-ma-option="size"].is-selected, ' +
      '[data-ma-option="frame"][aria-pressed="true"], [data-ma-option="size"][aria-pressed="true"]'
    );
  }

  function setFromState(detail) {
    var anySelected = hasAnySelection(detail);

    document.querySelectorAll('[data-ma-from]').forEach(function (el) {
      el.hidden = anySelected;
    });

    // Used only for compact lower-price typography while the From label exists.
    document.querySelectorAll('[data-ma-purchase-pricing]').forEach(function (pricing) {
      pricing.classList.toggle('ma-has-from', !anySelected);
    });
  }

  function visibleThumbs(r) {
    return Array.prototype.filter.call(r.querySelectorAll('[data-slideshow-thumbnail]'), function (el) {
      if (el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
      var cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden';
    });
  }

  function syncMainNav() {
    var r = root(), nav = document.querySelector('[data-ma-main-nav]');
    if (!r || !nav) return;
    var thumbs = visibleThumbs(r);
    if (!thumbs.length) return;
    var active = thumbs.findIndex(function (el) { return el.classList.contains('is-activated'); });
    if (active < 0) active = 0;
    var idx = nav.querySelector('[data-ma-main-index]');
    if (idx) idx.textContent = String(active + 1);
    var counter = idx && idx.parentElement;
    if (counter) {
      while (counter.childNodes.length > 1) counter.removeChild(counter.lastChild);
      counter.appendChild(document.createTextNode(' / ' + thumbs.length));
    }
    var prev = nav.querySelector('[data-ma-main-prev]'), next = nav.querySelector('[data-ma-main-next]');
    if (prev) prev.disabled = active <= 0;
    if (next) next.disabled = active >= thumbs.length - 1;
  }

  function moveMain(direction) {
    var r = root(); if (!r) return;
    var thumbs = visibleThumbs(r);
    if (!thumbs.length) return;
    var active = thumbs.findIndex(function (el) { return el.classList.contains('is-activated'); });
    if (active < 0) active = 0;
    var target = Math.max(0, Math.min(thumbs.length - 1, active + direction));
    if (target !== active) thumbs[target].click();
    schedule(syncMainNav);
  }

  function initNav() {
    var nav = document.querySelector('[data-ma-main-nav]'), r = root();
    if (!nav || !r || nav.dataset.maReady === 'true') return;
    nav.dataset.maReady = 'true';
    nav.querySelector('[data-ma-main-prev]')?.addEventListener('click', function () { moveMain(-1); });
    nav.querySelector('[data-ma-main-next]')?.addEventListener('click', function () { moveMain(1); });
    r.addEventListener('click', function (e) {
      if (e.target.closest('[data-slideshow-thumbnail]')) schedule(syncMainNav);
    });
    var holder = r.querySelector('[data-product-thumbs]');
    if (holder && window.MutationObserver) {
      new MutationObserver(function () { syncMainNav(); }).observe(holder, { subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    }
    schedule(syncMainNav);
  }

  function initCustomizerProxy() {
    document.querySelectorAll('[data-ma-build-custom]').forEach(function (link) {
      if (link.dataset.maProxyReady === 'true') return;
      link.dataset.maProxyReady = 'true';
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (href && href !== '#') return;
        var source = root() && root().querySelector('.ma-pdp-customizer-button-block a[href]');
        if (!source) return;
        e.preventDefault();
        if (source.target === '_blank') window.open(source.href, '_blank', 'noopener');
        else window.location.href = source.href;
      });
    });
  }

  function init() {
    if (!root()) return;
    initNav(); initCustomizerProxy(); syncTitlePrice(); setFromState(window.__maSelection || { complete: false });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('ma:selection', function (e) {
    setFromState(e.detail);
    schedule(syncTitlePrice);
  });

  document.addEventListener('ma:pdp-price-updated', function () {
    schedule(syncTitlePrice);
    schedule(function () { setFromState(window.__maSelection || null); });
  });
  document.addEventListener('theme:variant:change', function () {
    // Do not clone the price during the transient pre-discount state.
    // product-price-js publishes ma:pdp-price-updated after the final normal/
    // sale price is ready, and that event owns the visible price sync.
    schedule(syncMainNav);
    schedule(function () { setFromState(window.__maSelection || null); });
  });
  // Pipeline dispatches its section events on `window`, after the new DOM is in place.
  window.addEventListener('theme:section:update', init);
  document.addEventListener('shopify:section:load', init);
  // The sale line's fit depends on screen width and on the web fonts' widths.
  window.addEventListener('resize', function () { schedule(refitSaleLine); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refitSaleLine);
})();